// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ML-9","title":"AfterBackImages_title__Xw-h2","images":"AfterBackImages_images__-Os_X"};